module.exports = __webpack_public_path__ + "static/media/myb.b6208102.svg";